<template>
    <div class="initiationBox">
        <div>
            <div class="contractTitle">
                <div style="width: 5px;height: 18px;background-color: #409EFF"></div>
                <p>合同基本信息</p>
            </div>
            <div class="contractContent">
                <div class="contractName">
                    <el-form :model="ruleForm" :rules="rules" ref="ruleForm"  class="demo-ruleForm">
                        <el-form-item  label="合同名称" style="display: flex">
                            <el-input v-model="ruleForm.doc_title" placeholder="请输入合同名称" disabled></el-input>
                        </el-form-item>
                        <el-form-item  label="合同编号" style="display: flex">
                            <el-input v-model="ruleForm.contract_sn" placeholder="不填系统会自动生成"></el-input>
                        </el-form-item>
                        <el-form-item   label="签署截止时间" style="display: flex" prop="time">
                            <el-date-picker
                                style="width: 200px"
                                v-model="time"
                                :clearable="false"
                                type="date"
                                value-format="yyyy-MM-dd"
                                placeholder="选择日期">
                            </el-date-picker>
                        </el-form-item>
                    </el-form>
                </div>
            </div>
        </div>
<!--        设置签署方-->
            <div class="signatoryBox">
                <div class="signatory">
                    <div style="width: 5px;height: 18px;background-color: #409EFF"></div>
                    <p>设置签署方</p>
                </div>
                <div class="participateBox" >
                    <div class="participate">签署方类型</div>
                    <div class="keyWord">签署关键字</div>
                    <div class="signed">签署方信息</div>
                    <div class="operation">操作</div>
                </div>
                <div class="signatoryList" v-for="(item,index) in signatoryForm" :key="index">
                    <div class="choose" >
                        <el-select v-model="item.zt_type" placeholder="请选择" style="width: 100px">
                            <el-option label="企业" value="1"></el-option>
                            <el-option label="个人" value="2"></el-option>
                        </el-select>
                    </div>
                    <div class="signKey">
                        <el-input v-model="item.keyword" disabled class="mainBody" placeholder="请输入签署关键字" style="width: 150px"></el-input>
                    </div>
                    <div class="information">
                        <el-input v-model="item.name" class="mainBody" placeholder="请输入真实姓名"></el-input>
                        <el-input v-model="item.mobile" class="mainBody" placeholder="请输入手机号"></el-input>
                        <el-input v-model="item.com_name" class="mainBody" placeholder="请输入企业完整名称" v-if="item.zt_type==1"></el-input>
                    </div>
                    <div class="operate">
                        <el-button type="danger" @click="removeBtn(index)">删除</el-button>
                    </div>
                </div>
                <el-button type="primary" @click="addSign">添加签署方</el-button>
            </div>
        <p style="margin: 15px 0;color: #525961;font-size: 14px"><span style="color: red">注意：</span>1.请将上方的《签署关键字》设置在word文档中的盖章或签字处，并将关键字设置为不可见的白色字体
            2.同一个签署方如需在多处盖章或签字，请在对应的多处位置设置签署关键字
            3.将word文件转成pdf文件上传即可</p>
<!--     上传签署文件   -->
        <div class="uploadBox">
            <div class="uploadTitle">
                <div style="width: 5px;height: 18px;background-color: #409EFF"></div>
                <p>上传签署文件</p>
            </div>
            <div class="matter">
                <div class="fileContent">
                    <p style="color: #525961">签署文件:</p>
                </div>
                <el-upload
                    ref='upload'
                    :limit="1"
                    class="inline"
                    :on-preview="handlePreview"
                    :on-remove="(file, fileList) => {applicationRemove(file, fileList)}"
                    :on-success="handleSuccess"
                    :on-exceed="handleExceed"
                    accept=".pdf"
                    :headers="headers"
                    :action="url"
                    name="file"
                    :data="upload_data"
                    :file-list="application"
                >
                    <el-button class="custom">
                        上传
                    </el-button>
                </el-upload>
            </div>
        </div>
        <el-button style="display: block;margin: auto" type="primary" @click="submitBtn">发起合同</el-button>
    </div>
</template>

<script>
import { directInitiation } from '@/api/initiation';
import bus from '@/components/common/bus';

export default {
    name: "directInitiation",
    data() {
        return {
            url:process.env.VUE_APP_BASE_API+'/api/upload_direct_file',
            headers: {
                'Authorization': sessionStorage.getItem('token'),
                'Comid': sessionStorage.getItem('shenfen'),
                "Platformsn":JSON.parse(localStorage.getItem('userData')).platform_sn
            },
            ruleForm:{
                doc_title:'',
                contract_sn:'',
            },
            shenfen:'',
            fileId:'',
            upload_data:{

            },
            application:[],
            time:'',
            rules:{
                doc_title: [
                    { required: true, message: '合同名称不能为空', trigger: 'blur' },
                ],
                // time:[
                //     { required: true, message: '签署截止时间不能为空', trigger: 'blur' }
                // ]
            },
            signatoryForm:[
                {
                    zt_type:'1',
                    keyword:'sign0001',
                    name:'',
                    mobile:'',
                    com_name:'',
                }
            ],
        }
    },
    methods:{
        GetDateStr(date) {
            var dd = new Date();
            dd.setDate(dd.getDate() + date);//获取AddDayCount天后的日期
            var y = dd.getFullYear();
            var m = (dd.getMonth() + 1) < 10 ? "0" + (dd.getMonth() + 1) : (dd.getMonth() + 1);//获取当前月份的日期，不足10补0
            var d = dd.getDate() < 10 ? "0" + dd.getDate() : dd.getDate();//获取当前几号，不足10补0
            return y + "-" + m + "-" + d;
        },
        // 添加签署方
        addSign(){
            if (this.signatoryForm.length>=10){
                this.$message.error('最多添加10个签署方')
            }else {
                const nextNum=this.signatoryForm.length+1
                this.signatoryForm.push({
                    zt_type:'1',
                    keyword:`sign${String(nextNum).padStart(4,'0')}`,
                    name:'',
                    mobile:'',
                    com_name:'',
                })
            }
        },
        removeBtn(index){
            if (this.signatoryForm.length==1){
                this.$message.error('至少保留一个签署方')
            }else {
                this.signatoryForm.splice(index,1)
                this.signatoryForm.forEach((item,index)=>{
                    item.keyword=`sign${String(index+1).padStart(4,'0')}`
                })
            }
        },
        //点击文件列表事件
        handlePreview(file){
            if (file.all_url){
                const link = document.createElement("a"); //自己创建的a标签
                link.href = file.all_url+'?v='+Math.random();
                link.target="_blank"
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
                window.URL.revokeObjectURL(file.all_url);
            }else if (file.response){
                const link = document.createElement("a"); //自己创建的a标签
                link.href = file.response.data.all_url+'?v='+Math.random();
                link.target="_blank"
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
                window.URL.revokeObjectURL(file.response.data.all_url);
            }
        },
        applicationRemove(){

        },
        //上传成功
        handleSuccess(response, file, fileList){
            if (response.code == 200){
                this.fileId = response.data.fileId
                this.ruleForm.doc_title = response.data.doc_title;
            }else {
                this.$message.error(response.msg);
            }
        },
        //限制上传个数
        handleExceed(files, fileList){
            if (fileList.length>=1){
                this.$message.error('只能上传1个文件');
            }
        },
        // 发起合同
        submitBtn(){
            this.$refs.ruleForm.validate((valid) => {
                if (valid) {
                    for(const item of this.signatoryForm){
                        if(!item.name) return this.$message.error('请填写姓名')
                        if(!item.mobile) return this.$message.error('请填写手机号')
                        if(item.zt_type == 1 && !item.com_name) return this.$message.error('请填写企业名称')
                    }

                    if(!this.fileId) return this.$message.error('请先上传签署文件')

                    this.$confirm('请确认是否发起合同 ', '提示', {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        type: 'warning'
                    }).then(() => {
                        let data={
                            doc_title:this.ruleForm.doc_title,
                            contract_sn:this.ruleForm.contract_sn,
                            expire_time:this.time,
                            signers:this.signatoryForm,
                            fileId:this.fileId,
                        }
                        // this.signatoryForm.some(item=>{
                        //     console.log(item);
                        //     // 如果当前签署方类型是企业并且当前账号用户类型是企业管理员或者企业员工
                        //     if (item.zt_type == 1 && this.shenfen.user_type == 2 || this.shenfen.user_type == 3){
                        //         // 如果输入框中的公司名字和账号名字一样并且姓名和员工名字一样
                        //         if (item.com_name == this.shenfen.name && item.name == this.shenfen.yg_name){
                        //             console.log('数据一致');
                        //         }
                        //     }
                        //     // 如果当前签署方类型是个人并且当前账号用户类型是个人
                        //     if (item.zt_type == 2 && this.shenfen.user_type == 1){
                        //         if(item.name == this.shenfen.name){
                        //             console.log('数据一致');
                        //         }
                        //     }
                        // })
                        directInitiation(data).then(res=>{
                            if (res.code==200){
                                this.$message.success(res.msg)
                                bus.$emit('close_current_tags')
                                if (res.data.is_canyu==0){
                                    this.$router.push({ path: '/contract', query: { type: 'fifth' } });
                                }else if (res.data.is_canyu==1){
                                    this.$router.push({ path: '/contract', query: { type: 'fourth' } });
                                }
                            }else {
                                this.$message.error(res.msg)
                            }
                        })
                    }).catch(() => {

                    });
                }else {
                    return false
                }
            })
        }
    },
    created() {
        this.headers.Comid = JSON.parse(sessionStorage.getItem('shenfen')).com_id;
        this.shenfen =JSON.parse(sessionStorage.getItem('shenfen'))
        this.time=this.GetDateStr(89)
    }
}
</script>

<style scoped>
    .initiationBox{
        padding: 20px;
        background-color: #fff;
        border-radius: 5px;
    }
    .contractTitle{
        display: flex;
        align-items: center;
    }
    .contractTitle>p{
        margin-left: 10px;
    }
    .contractContent{
        margin: 10px 0px;
        overflow: hidden;
        color: #333333;
    }
    .contractName{
        display: flex;
        margin: 10px 0px;
        align-items: center;
    }
    .contractCopies>p{
        margin-left: 10px;
    }
    ::v-deep .el-form-item__label{
        width: 120px;
    }
    .signatory{
        display: flex;
        align-items: center;
    }
    .signatory>p{
        margin-left: 10px;
    }
    .participateBox{
        display: flex;
        align-items: center;
        height: 50px;
        background-color: #f3f3f9;
        color: #525961;
        padding: 0px 20px;
        margin: 20px 0;
    }
    .participate{
        width: 15%;
    }
    .keyWord{
        width: 20%;
    }
    .signed{
        width: 50%;
    }
    .operation{
        width: 15%;
        text-align: center;
    }
    .signatoryList{
        display: flex;
        margin: 20px 0px;
    }
    .choose{
        width: 15%;
    }
    .signKey{
        width: 20%;
    }
    .information{
        width: 50%;
        display: flex;
    }
    .operate{
        width: 15%;
        text-align: center;
    }
    .mainBody{
        margin-right: 10px;
    }
    .uploadTitle{
        display: flex;
        align-items: center;
    }
    .uploadTitle>p{
        margin-left: 10px;
    }
    .uploadBox{
        margin: 20px 0;
    }
    .matter{
        display: flex;
        align-items: center;
        margin: 20px;
    }

    .inline{
        /*width: 50%;*/
        height: 32px;
        margin: 0px 15px;
        display: flex;
        align-items: center;
    }
    ::v-deep .el-upload--text{
        width: 60px;
        line-height: 30px;
        height: 100%;
        border: 0px;
        color: #fff;
    }
    .preserve>button{
        background-color: #409EFF;
        color: #ffffff;
    }

    .custom{
        background-color: #409EFF;
        color: #fff;
    }
    ::v-deep .el-upload-list__item{
        margin-top: 0;
    }
</style>